/** 浏览器活动页 → 主站登录 → 回跳活动详情 */

export const ACTIVITY_RETURN_URL_KEY = 'difi_activity_return_url';

function resolveMainSiteOrigin(): string {
  const raw = String(import.meta.env.VITE_BASE_URL || '')
    .trim()
    .replace(/\/$/, '');
  if (/^https?:\/\//i.test(raw)) return raw;
  if (typeof window !== 'undefined') {
    if (raw.startsWith('/')) return `${window.location.origin}${raw}`;
    return window.location.origin;
  }
  return raw || '';
}

function isAllowedActivityReturnUrl(href: string): boolean {
  try {
    const u = new URL(href);
    const base = resolveMainSiteOrigin();
    let baseOrigin = '';
    try {
      baseOrigin = base ? new URL(base).origin : '';
    } catch {
      baseOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    }
    const pageOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    if (u.origin !== baseOrigin && u.origin !== pageOrigin) return false;
    return /\/activity(?:\/|$)/i.test(u.pathname);
  } catch {
    return false;
  }
}

export function saveActivityReturnUrl(url = typeof window !== 'undefined' ? window.location.href : ''): void {
  const href = String(url || '').trim();
  if (!href || !isAllowedActivityReturnUrl(href)) return;
  try {
    sessionStorage.setItem(ACTIVITY_RETURN_URL_KEY, href);
  } catch {
    /* ignore */
  }
}

/** 取出并清除回跳地址；非法则返回 null */
export function takeActivityReturnUrl(): string | null {
  try {
    const raw = String(sessionStorage.getItem(ACTIVITY_RETURN_URL_KEY) || '').trim();
    sessionStorage.removeItem(ACTIVITY_RETURN_URL_KEY);
    if (!raw || !isAllowedActivityReturnUrl(raw)) return null;
    return raw;
  } catch {
    return null;
  }
}

/** 跳主站并强制弹出登录层；登录成功后由 finishLogin 回活动 */
export function goMainSiteLoginForActivity(): void {
  saveActivityReturnUrl();
  const origin = resolveMainSiteOrigin() || (typeof window !== 'undefined' ? window.location.origin : '');
  const next = `${origin.replace(/\/$/, '')}/?activityLogin=1`;
  window.location.href = next;
}
